import React, { FC } from 'react';
import SectionContainer from '@common/components/SectionContainer';
import { Category } from 'shared-types/Common';
import { useTranslations } from '@lang';
import { CategoryGrid } from '@common/components/CategoryGrid';
import { FeaturedCategoriesWrapper, FeaturedTitle } from '@routes/Home/components/Featured.styles';

type FeaturedCategoriesProps = {
  categories: Category[];
};

export const FeaturedCategories: FC<FeaturedCategoriesProps> = ({ categories = [] }) => {
  const { t } = useTranslations();

  return (
    <FeaturedCategoriesWrapper>
      <SectionContainer>
        <FeaturedTitle>{t('homepage.featuredCollections')}</FeaturedTitle>
        <CategoryGrid categories={categories} />
      </SectionContainer>
    </FeaturedCategoriesWrapper>
  );
};
